import React from 'react'
import { useIntl, defineMessage } from 'react-intl'
import { ICustomerAddress } from 'msp-integrations'

type AddressDisplayProps = {
  className?: string
  address: ICustomerAddress
}

const AddressDisplay = ({ className = '', address }: AddressDisplayProps) => {
  const { formatMessage } = useIntl()
  const translations = {
    MR: defineMessage({
      defaultMessage: 'Mr',
      id: 'msp.address_form.salutation.mr'
    }),
    MRS: defineMessage({
      defaultMessage: 'Mrs',
      id: 'msp.address_form.salutation.mrs'
    }),
    _: defineMessage({
      defaultMessage: ' ',
      id: 'msp.address_form.salutation.none'
    })
  }

  const getSalutation = () =>
    formatMessage(
      translations[
        address.salutation === 'undefined' || !address.salutation
          ? '_'
          : address.salutation
      ]
    )

  return (
    <div className={`font-Roboto text-14 leading-24 tracking-0 ${className}`}>
      {address?.c_isPackstation && (
        <div>
          <span className='italic'>
            {formatMessage({
              defaultMessage: 'To the attention of :',
              id: 'msp.address_form.packstation.attention'
            })}
          </span>
          <span className='font-medium'>
            {` ${getSalutation()} ${address.firstName} ${address.lastName}`}
          </span>
        </div>
      )}
      {!address?.c_isPackstation && (
        <div>
          {` ${getSalutation()} ${address.firstName} ${address.lastName}`}
        </div>
      )}
      <div>{address.address1}</div>
      <div>
        {address.countryCode}-{address.postalCode} {address.city}
      </div>
    </div>
  )
}

export default AddressDisplay
